<template>
    <default-modal
        class="default-modal-margin"
        :show="showModal"
        :height="0"
        :closeOnClickModal="false"
        @close="closeModal"
    >
        Do you want to export all completed schedulings<br> from the past 3 months in CSV format ?
        <div class="modal-action-button-container">
            <el-button
                class="delete-event-cancel-btn"
                type="text"
                small
                :loading="loading"
                @click="closeModal"
            >Cancel</el-button>
            <download-csv-button
                :url="exportUrl"
                modelName="schedulings"
                :scoped="true"
                ref="download"
                @click.native="closeModal"
            >
            </download-csv-button>
        </div>
    </default-modal>
</template>

<script>

import moment from 'moment';
import DefaultModal from 'gcmcn-common/src/components/gcmcn-modal-theme.vue';
import DownloadCsvButton from 'fundation-app-vuejs/src/components/partials/nsPaginate/download-csv-button.vue';

export default {

    name: 'export-csv-button',
    components:{
        DefaultModal,
        DownloadCsvButton
    },
    props:{
        channel: {
            type: Object,
            required: true,
        }
    },
    data () {
        return {
            showModal: false,
            csvIsLoading: false,
            loading: false,
            url: ''
        };
    },
    mounted(){
    },
    computed: {
        exportUrl(){
            let channelUid = this.channel.uid;
            let pastThreeMonths = moment.utc().subtract(3, 'months').format('YYYY-MM-DDTHH:mm:ss[Z]');
            return `scheduling/?status=COMPLETED&channel=${channelUid}&start_date__range=${pastThreeMonths},`;
        }
    },
    methods:{
        open (){
            this.showModal = true;
        },
        closeModal (){
            this.showModal = false;
        },
    }
};
</script>

<style lang="css" scoped>
.default-modal-margin{
    margin-top: 12em;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Channels/SchedulingsView/modal-export-csv.vue